import { render } from "./RefferalInfo.vue?vue&type=template&id=64bfeed3"
import script from "./RefferalInfo.vue?vue&type=script&lang=js"
export * from "./RefferalInfo.vue?vue&type=script&lang=js"

import "./RefferalInfo.vue?vue&type=style&index=0&id=64bfeed3&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__